// Cal3.4.0 / 2012-10-22
// SYNCK GRAPHICA
// charset UTF-8

var calObj = new Array();

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// *****************
// *********************
// ************************ 【https://www.strapya.com/上のカレンダーは全て "calObj[0]"を使用しております。"calObj[1]"を更新してもサイト上には反映されません】

//【以下カレンダー0の設定】

// [0]は0番目のカレンダーってことね。
calObj[0] = new Object();

// xヶ月後のカレンダーを初期表示するか (0の場合は当月)
calObj[0].defaultMonth = 0;

// ["day"] 日付に対してのクラス指定
calObj[0].daysClass = new Object();
//calObj[0].daysClass["2012/6/9"] = 'Birthday;和田憲幸の33歳の誕生日だゾ☆<br />クリックすると開きます何かが。;';
// 2012/6/9にBirthdayクラスを指定ってことね(和田の誕生日です)。
// セミコロンで区切ると説明コメント、URLを付けることができます(全クラス指定共通)。
//calObj[0].daysClass["6/9"] = 'Birthday;和田憲幸の誕生日だゾ☆<br />年を抜くと毎年。;';


// ["xDaysLater"] ○日後のクラス指定
calObj[0].xDaysLater = new Array();
calObj[0].xDaysLater[0] = 'Today'; // 0日後にTodayクラスを指定ってことね。
//calObj[0].xDaysLater[1] = 'Tomorrow;君たちにとっては明日の出来事だ。'; // 1日後にTomorrowクラスを指定ってことね。
//calObj[0].xDaysLater[4] = 'Deli;本日注文の場合の発送予定日'; // 1日後にTomorrowクラスを指定ってことね。

calObj[0].daysClass["2021/1/4"] = 'shipping';
calObj[0].daysClass["2021/1/9"] = 'shipping';
calObj[0].daysClass["2021/1/11"] = 'shipping';
calObj[0].daysClass["2021/1/16"] = 'shipping';
calObj[0].daysClass["2021/1/17"] = 'shipping';
calObj[0].daysClass["2021/1/23"] = 'shipping';
calObj[0].daysClass["2021/1/24"] = 'shipping';
calObj[0].daysClass["2021/1/30"] = 'shipping';
calObj[0].daysClass["2021/1/31"] = 'shipping';
calObj[0].daysClass["2021/1/1"] = 'Holyday';
calObj[0].daysClass["2021/1/2"] = 'Holyday';
calObj[0].daysClass["2021/1/3"] = 'Holyday';
calObj[0].daysClass["2021/1/10"] = 'Holyday';
calObj[0].daysClass["2021/2/6"] = 'shipping';
calObj[0].daysClass["2021/2/7"] = 'shipping';
calObj[0].daysClass["2021/2/13"] = 'shipping';
calObj[0].daysClass["2021/2/14"] = 'shipping';
calObj[0].daysClass["2021/2/20"] = 'shipping';
calObj[0].daysClass["2021/2/21"] = 'shipping';
calObj[0].daysClass["2021/2/27"] = 'shipping';
calObj[0].daysClass["2021/2/28"] = 'shipping';
calObj[0].daysClass["2021/2/11"] = 'Holyday';
calObj[0].daysClass["2021/2/23"] = 'Holyday';
calObj[0].daysClass["2021/3/6"] = 'shipping';
calObj[0].daysClass["2021/3/7"] = 'shipping';
calObj[0].daysClass["2021/3/13"] = 'shipping';
calObj[0].daysClass["2021/3/14"] = 'shipping';
calObj[0].daysClass["2021/3/21"] = 'shipping';
calObj[0].daysClass["2021/3/27"] = 'shipping';
calObj[0].daysClass["2021/4/30"] = 'Holyday';
calObj[0].daysClass["2021/4/23"] = 'shipping';
calObj[0].daysClass["2021/5/1"] = 'Holyday';
calObj[0].daysClass["2021/5/3"] = 'Holyday';
calObj[0].daysClass["2021/5/4"] = 'Holyday';
calObj[0].daysClass["2021/5/5"] = 'shipping';
calObj[0].daysClass["2021/5/6"] = 'shipping';
calObj[0].daysClass["2021/5/16"] = 'Holyday';
calObj[0].daysClass["2021/6/26"] = 'Holyday';
calObj[0].daysClass["2021/7/22"] = 'Holyday';
calObj[0].daysClass["2021/7/23"] = 'shipping';
calObj[0].daysClass["2021/8/8"] = 'Holyday';
calObj[0].daysClass["2021/8/9"] = 'shipping';
calObj[0].daysClass["2021/9/19"] = 'Holyday';
calObj[0].daysClass["2021/10/21"] = 'shipping';
calObj[0].daysClass["2021/11/1"] = 'Holyday';
calObj[0].daysClass["2021/11/3"] = 'shipping';
calObj[0].daysClass["2021/11/23"] = 'shipping';
calObj[0].daysClass["2021/12/29"] = 'Holyday';
calObj[0].daysClass["2022/1/1"] = 'Holyday';
calObj[0].daysClass["2022/1/2"] = 'Holyday';
calObj[0].daysClass["2022/1/3"] = 'Holyday';
calObj[0].daysClass["2022/1/4"] = 'shipping';
calObj[0].daysClass["2022/1/10"] = 'shipping';
calObj[0].daysClass["2022/2/11"] = 'shipping';
calObj[0].daysClass["2022/2/23"] = 'shipping';
calObj[0].daysClass["2022/3/21"] = 'shipping';
calObj[0].daysClass["2022/4/20"] = 'shipping';
calObj[0].daysClass["2022/4/29"] = 'shipping';
calObj[0].daysClass["2022/5/1"] = 'Holyday';
calObj[0].daysClass["2022/5/2"] = 'Holyday';
calObj[0].daysClass["2022/5/3"] = 'Holyday';
calObj[0].daysClass["2022/5/4"] = 'Holyday';
calObj[0].daysClass["2022/5/5"] = 'Holyday';
calObj[0].daysClass["2022/5/15"] = 'Holyday';
calObj[0].daysClass["2022/6/25"] = 'Holyday';
calObj[0].daysClass["2022/8/11"] = 'shipping';
calObj[0].daysClass["2022/9/19"] = 'shipping';
calObj[0].daysClass["2022/9/23"] = 'shipping';
calObj[0].daysClass["2022/9/25"] = 'Holyday';
calObj[0].daysClass["2022/10/10"] = 'shipping';
calObj[0].daysClass["2022/11/3"] = 'shipping';
calObj[0].daysClass["2022/11/5"] = 'shipping';
calObj[0].daysClass["2022/11/6"] = 'shipping';
calObj[0].daysClass["2022/11/12"] = 'shipping';
calObj[0].daysClass["2022/11/13"] = 'shipping';
calObj[0].daysClass["2022/11/19"] = 'shipping';
calObj[0].daysClass["2022/11/20"] = 'shipping';
calObj[0].daysClass["2022/11/26"] = 'shipping';
calObj[0].daysClass["2022/11/27"] = 'shipping';
calObj[0].daysClass["2022/11/1"] = 'Holyday';
calObj[0].daysClass["2022/11/2"] = 'Holyday';
calObj[0].daysClass["2022/11/23"] = 'Holyday';
calObj[0].daysClass["2022/12/3"] = 'shipping';
calObj[0].daysClass["2022/12/4"] = 'shipping';
calObj[0].daysClass["2022/12/10"] = 'shipping';
calObj[0].daysClass["2022/12/11"] = 'shipping';
calObj[0].daysClass["2022/12/17"] = 'shipping';
calObj[0].daysClass["2022/12/18"] = 'shipping';
calObj[0].daysClass["2022/12/24"] = 'shipping';
calObj[0].daysClass["2022/12/25"] = 'shipping';
calObj[0].daysClass["2022/12/29"] = 'shipping';
calObj[0].daysClass["2022/12/30"] = 'Holyday';
calObj[0].daysClass["2022/12/31"] = 'Holyday';
calObj[0].daysClass["2023/1/1"] = 'Holyday';
calObj[0].daysClass["2023/1/2"] = 'Holyday';
calObj[0].daysClass["2023/1/3"] = 'Holyday';
calObj[0].daysClass["2023/1/4"] = 'shipping';
calObj[0].daysClass["2023/1/7"] = 'shipping';
calObj[0].daysClass["2023/1/8"] = 'Holyday';
calObj[0].daysClass["2023/1/9"] = 'shipping';
calObj[0].daysClass["2023/1/14"] = 'shipping';
calObj[0].daysClass["2023/1/15"] = 'shipping';
calObj[0].daysClass["2023/1/21"] = 'shipping';
calObj[0].daysClass["2023/1/22"] = 'shipping';
calObj[0].daysClass["2023/1/28"] = 'shipping';
calObj[0].daysClass["2023/1/29"] = 'shipping';
calObj[0].daysClass["2023/2/4"] = 'shipping';
calObj[0].daysClass["2023/2/5"] = 'shipping';
calObj[0].daysClass["2023/2/11"] = 'shipping';
calObj[0].daysClass["2023/2/12"] = 'shipping';
calObj[0].daysClass["2023/2/18"] = 'shipping';
calObj[0].daysClass["2023/2/19"] = 'shipping';
calObj[0].daysClass["2023/2/23"] = 'Holyday';
calObj[0].daysClass["2023/2/25"] = 'shipping';
calObj[0].daysClass["2023/2/26"] = 'shipping';
calObj[0].daysClass["2023/3/4"] = 'shipping';
calObj[0].daysClass["2023/3/5"] = 'shipping';
calObj[0].daysClass["2023/3/11"] = 'shipping';
calObj[0].daysClass["2023/3/12"] = 'shipping';
calObj[0].daysClass["2023/3/18"] = 'shipping';
calObj[0].daysClass["2023/3/19"] = 'shipping';
calObj[0].daysClass["2023/3/21"] = 'shipping';
calObj[0].daysClass["2023/3/25"] = 'shipping';
calObj[0].daysClass["2023/3/26"] = 'shipping';
calObj[0].daysClass["2023/4/30"] = 'Holyday';
calObj[0].daysClass["2023/5/1"] = 'Holyday';
calObj[0].daysClass["2023/5/3"] = 'Holyday';
calObj[0].daysClass["2023/5/4"] = 'Holyday';
calObj[0].daysClass["2023/5/5"] = 'Holyday';
calObj[0].daysClass["2023/5/6"] = 'shipping';
calObj[0].daysClass["2023/5/7"] = 'shipping';
calObj[0].daysClass["2023/5/13"] = 'shipping';
calObj[0].daysClass["2023/5/14"] = 'shipping';
calObj[0].daysClass["2023/5/19"] = 'shipping';
calObj[0].daysClass["2023/5/20"] = 'shipping';
calObj[0].daysClass["2023/5/21"] = 'shipping';
calObj[0].daysClass["2023/5/27"] = 'shipping';
calObj[0].daysClass["2023/5/28"] = 'Holyday';
calObj[0].daysClass["2023/6/3"] = 'shipping';
calObj[0].daysClass["2023/6/4"] = 'shipping';
calObj[0].daysClass["2023/6/10"] = 'shipping';
calObj[0].daysClass["2023/6/11"] = 'shipping';
calObj[0].daysClass["2023/6/17"] = 'shipping';
calObj[0].daysClass["2023/6/18"] = 'shipping';
calObj[0].daysClass["2023/6/24"] = 'Holyday';
calObj[0].daysClass["2023/6/25"] = 'shipping';
calObj[0].daysClass["2023/7/17"] = 'shipping';
calObj[0].daysClass["2023/10/31"] = 'Holyday';
calObj[0].daysClass["2023/11/1"] = 'Holyday';
calObj[0].daysClass["2023/11/10"] = 'shipping';
calObj[0].daysClass["2023/12/29"] = 'Holyday';
calObj[0].daysClass["2023/12/30"] = 'Holyday';
calObj[0].daysClass["2023/12/31"] = 'Holyday';
calObj[0].daysClass["2024/1/1"] = 'Holyday';
calObj[0].daysClass["2024/1/2"] = 'Holyday';
calObj[0].daysClass["2024/1/3"] = 'Holyday';
calObj[0].daysClass["2024/1/4"] = 'shipping';
calObj[0].daysClass["2024/2/12"] = 'shipping';
calObj[0].daysClass["2024/4/30"] = 'Holyday';
calObj[0].daysClass["2024/5/1"] = 'Holyday';
calObj[0].daysClass["2024/5/5"] = 'Holyday';
calObj[0].daysClass["2024/5/10"] = 'shipping';
calObj[0].daysClass["2024/5/26"] = 'Holyday';
calObj[0].daysClass["2024/6/29"] = 'Holyday';
calObj[0].daysClass["2024/5/28"] = 'shipping';
calObj[0].daysClass["2024/11/8"] = 'shipping';
calObj[0].daysClass["2024/12/30"] = 'Holyday';
calObj[0].daysClass["2024/12/31"] = 'Holyday';
calObj[0].daysClass["2025/1/1"] = 'Holyday';
calObj[0].daysClass["2025/1/2"] = 'Holyday';
calObj[0].daysClass["2025/1/3"] = 'Holyday';
calObj[0].daysClass["2025/1/4"] = 'Holyday';
calObj[0].daysClass["2025/1/5"] = 'Holyday';
calObj[0].daysClass["2025/4/30"] = 'Holyday';
calObj[0].daysClass["2025/4/15"] = 'shipping';
calObj[0].daysClass["2025/4/16"] = 'shipping';
calObj[0].daysClass["2025/5/1"] = 'Holyday';
calObj[0].daysClass["2025/5/6"] = 'shipping';
calObj[0].daysClass["2025/5/23"] = 'shipping';
calObj[0].daysClass["2025/6/28"] = 'Holyday';
calObj[0].daysClass["2025/7/13"] = 'Holyday';
calObj[0].daysClass["2025/10/31"] = 'Holyday';
calObj[0].daysClass["2025/11/7"] = 'shipping';
calObj[0].daysClass["2025/11/24"] = 'shipping';
calObj[0].daysClass["2025/12/30"] = 'Holyday';
calObj[0].daysClass["2025/12/31"] = 'Holyday';
calObj[0].daysClass["2026/1/1"] = 'Holyday';
calObj[0].daysClass["2026/1/2"] = 'Holyday';
calObj[0].daysClass["2026/1/3"] = 'Holyday';
calObj[0].daysClass["2026/3/20"] = 'shipping'; //春分の日
calObj[0].daysClass["2026/5/1"] = 'Holyday'; //棚卸
calObj[0].daysClass["2026/6/27"] = 'Holyday';//倉庫点検
calObj[0].daysClass["2026/8/23"] = 'Holyday';//電気点検
calObj[0].daysClass["2026/9/22"] = 'shipping';//国民の休日
calObj[0].daysClass["2026/11/2"] = 'Holyday';

// ["xDay"] 毎月○日のクラス指定
calObj[0].xDays = new Array();
//calObj[0].xDays[1] = 'Sale;毎月1日は激安セールの日☆'; // 毎月1日にSaleクラスを指定ってことね。

// ["week"] 毎週○曜日の場合
calObj[0].week = new Array();
calObj[0].week[0] = "shipping"; // Sun
calObj[0].week[1]; // Mon
calObj[0].week[2]; // Tue
calObj[0].week[3]; // Wed
calObj[0].week[4]; // Thu
calObj[0].week[5]; // Fri
calObj[0].week[6] = "shipping"; // Sat

// (○月) 第× △曜日の場合
calObj[0].month = new Object();
// 毎月「曜日-第○」 日:0 / 月:1 / 火:2 / 水:3 / 木:4 / 金:5 / 土:6
//calObj[0].month["0-4"] = 'Holyday;第2月曜日'; // 第2火曜日はHolydayクラス指定
//calObj[0].month["2-2"] = 'Holyday;第2火曜日は定休日です☆'; // 第2火曜日はHolydayクラス指定
//tddfsfcalObj[0].month["2-4"] = 'Holyday;第4火曜日は定休日です☆'; // 第4火曜日はHolydayクラス指定

// 【祝日の設定】
// 固定月「月-曜日-第○」 日:0 / 月:1 / 火:2 / 水:3 / 木:4 / 金:5 / 土:6
calObj[0].daysClass["1/1"] = 'shipping'; // 1月1日
calObj[0].daysClass["1/2"] = 'shipping'; // 1月2日
calObj[0].month["1-1-2"] = 'shipping'; // 1月 月曜日(1) 第2 ということね。【成人の日】
calObj[0].daysClass["2/11"] = 'shipping'; //【建国記念日】
calObj[0].daysClass["2/23"] = 'shipping'; //【天皇誕生日】
calObj[0].daysClass["4/29"] = 'shipping'; //【昭和の日】
calObj[0].daysClass["5/3"] = 'shipping'; //【憲法記念日】
calObj[0].daysClass["5/4"] = 'shipping'; //【みどりの日】
calObj[0].daysClass["5/5"] = 'shipping'; //【こどもの日】
calObj[0].month["7-1-3"] = 'shipping'; // 7月 月曜日(1) 第3 ということね。【海の日】
calObj[0].daysClass["8/11"] = 'shipping'; //【山の日】
calObj[0].month["9-1-3"] = 'shipping'; // 9月 月曜日(1) 第3 ということね。【敬老の日】
calObj[0].daysClass["9/23"] = 'shipping'; //【秋分の日】
calObj[0].month["10-1-2"] = 'shipping'; // 10月 月曜日(1) 第2 ということね。【スポーツの日】
calObj[0].daysClass["11/3"] = 'shipping'; //【文化の日】
calObj[0].daysClass["11/23"] = 'shipping'; //【勤労感謝の日】

// → 祝日参考記事：https://www.heart-denpo.com/manual-qa/manual/holiday.php

// ["backward"] 過去の日付のクラス名(指定しない場合はnull)
calObj[0].backward = 'backward';

// カレンダーをクリックできるようにする場合 (有効 : true / 無効 : false)
// クラス指定でURLが指定されている場合はそっちが優先されます。
calObj[0].click = false;

// クリックした時に開くURL ( _YEAR_ : 年 / _MONTH_ : 月 / _DAY_ : 日 )
calObj[0].clickURI = '';

// クリック可能にしたいクラス名 (すべての日をクリック可能にする場合は空にしてください)
// Holyday と指定した場合はclassがHolyday指定された日付だけクリックできるようになります。
calObj[0].clickClassName = "";

// 優先度 クラス指定する順番が変わります。
calObj[0].priority = new Array('week','xDay','xDaysLater','day','backward');

//【カレンダー0の設定はここまで】

// [0]のカレンダーを[1]にコピーしてちょっと修正する。
calObj[1] = new Object();

// xヶ月後のカレンダーを初期表示するか (0の場合は当月)
calObj[1].defaultMonth = 0;

// ["day"] 日付に対してのクラス指定
calObj[1].daysClass = new Object();
//calObj[0].daysClass["2012/6/9"] = 'Birthday;和田憲幸の33歳の誕生日だゾ☆<br />クリックすると開きます何かが。;';
// 2012/6/9にBirthdayクラスを指定ってことね(和田の誕生日です)。
// セミコロンで区切ると説明コメント、URLを付けることができます(全クラス指定共通)。
//calObj[0].daysClass["6/9"] = 'Birthday;和田憲幸の誕生日だゾ☆<br />年を抜くと毎年。;';


// ["xDaysLater"] ○日後のクラス指定
calObj[1].xDaysLater = new Array();
calObj[1].xDaysLater[0] = 'Today'; // 0日後にTodayクラスを指定ってことね。
//calObj[0].xDaysLater[1] = 'Tomorrow;君たちにとっては明日の出来事だ。'; // 1日後にTomorrowクラスを指定ってことね。
//calObj[0].xDaysLater[4] = 'Deli;本日注文の場合の発送予定日'; // 1日後にTomorrowクラスを指定ってことね。

calObj[1].daysClass["2021/1/4"] = 'shipping';
calObj[1].daysClass["2021/1/9"] = 'shipping';
calObj[1].daysClass["2021/1/11"] = 'shipping';
calObj[1].daysClass["2021/1/16"] = 'shipping';
calObj[1].daysClass["2021/1/17"] = 'shipping';
calObj[1].daysClass["2021/1/23"] = 'shipping';
calObj[1].daysClass["2021/1/24"] = 'shipping';
calObj[1].daysClass["2021/1/30"] = 'shipping';
calObj[1].daysClass["2021/1/31"] = 'shipping';
calObj[1].daysClass["2021/1/1"] = 'Holyday';
calObj[1].daysClass["2021/1/2"] = 'Holyday';
calObj[1].daysClass["2021/1/3"] = 'Holyday';
calObj[1].daysClass["2021/1/10"] = 'Holyday';
calObj[1].daysClass["2021/2/6"] = 'shipping';
calObj[1].daysClass["2021/2/7"] = 'shipping';
calObj[1].daysClass["2021/2/13"] = 'shipping';
calObj[1].daysClass["2021/2/14"] = 'shipping';
calObj[1].daysClass["2021/2/20"] = 'shipping';
calObj[1].daysClass["2021/2/21"] = 'shipping';
calObj[1].daysClass["2021/2/27"] = 'shipping';
calObj[1].daysClass["2021/2/28"] = 'shipping';
calObj[1].daysClass["2021/2/11"] = 'Holyday';
calObj[1].daysClass["2021/2/23"] = 'Holyday';
calObj[1].daysClass["2021/3/6"] = 'shipping';
calObj[1].daysClass["2021/3/7"] = 'shipping';
calObj[1].daysClass["2021/3/13"] = 'shipping';
calObj[1].daysClass["2021/3/14"] = 'shipping';
calObj[1].daysClass["2021/3/21"] = 'shipping';
calObj[1].daysClass["2021/3/27"] = 'shipping';
calObj[1].daysClass["2021/3/28"] = 'shipping';
calObj[1].daysClass["2021/3/20"] = 'Holyday';
calObj[1].daysClass["2021/4/23"] = 'shipping';
calObj[1].daysClass["2021/4/30"] = 'Holyday';
calObj[1].daysClass["2021/5/1"] = 'Holyday';
calObj[1].daysClass["2021/5/3"] = 'Holyday';
calObj[1].daysClass["2021/5/4"] = 'Holyday';
calObj[1].daysClass["2021/5/5"] = 'shipping';
calObj[1].daysClass["2021/5/6"] = 'shipping';
calObj[1].daysClass["2021/5/16"] = 'Holyday';
calObj[1].daysClass["2021/6/26"] = 'Holyday';
calObj[1].daysClass["2021/7/22"] = 'Holyday';
calObj[1].daysClass["2021/7/23"] = 'shipping';
calObj[1].daysClass["2021/8/8"] = 'Holyday';
calObj[1].daysClass["2021/8/9"] = 'shipping';
calObj[1].daysClass["2021/9/19"] = 'Holyday';
calObj[1].daysClass["2021/10/21"] = 'shipping';
calObj[1].daysClass["2021/11/1"] = 'Holyday';
calObj[1].daysClass["2021/11/3"] = 'shipping';
calObj[1].daysClass["2021/11/23"] = 'shipping';
calObj[1].daysClass["2021/12/29"] = 'Holyday';
calObj[1].daysClass["2022/1/1"] = 'Holyday';
calObj[1].daysClass["2022/1/2"] = 'Holyday';
calObj[1].daysClass["2022/1/3"] = 'Holyday';
calObj[1].daysClass["2022/1/4"] = 'shipping';
calObj[1].daysClass["2022/1/10"] = 'shipping';
calObj[1].daysClass["2022/2/11"] = 'shipping';
calObj[1].daysClass["2022/2/23"] = 'shipping';
calObj[1].daysClass["2022/3/21"] = 'shipping';
calObj[1].daysClass["2022/4/20"] = 'shipping';
calObj[1].daysClass["2022/4/29"] = 'shipping';
calObj[1].daysClass["2022/5/1"] = 'Holyday';
calObj[1].daysClass["2022/5/2"] = 'Holyday';
calObj[1].daysClass["2022/5/3"] = 'Holyday';
calObj[1].daysClass["2022/5/4"] = 'Holyday';
calObj[1].daysClass["2022/5/5"] = 'Holyday';
calObj[1].daysClass["2022/5/15"] = 'Holyday';
calObj[1].daysClass["2022/6/25"] = 'Holyday';
calObj[1].daysClass["2022/8/11"] = 'shipping';
calObj[1].daysClass["2022/9/19"] = 'shipping';
calObj[1].daysClass["2022/9/23"] = 'shipping';
calObj[1].daysClass["2022/9/25"] = 'Holyday';
calObj[1].daysClass["2022/10/10"] = 'shipping';
calObj[1].daysClass["2022/11/3"] = 'shipping';
calObj[1].daysClass["2022/11/5"] = 'shipping';
calObj[1].daysClass["2022/11/6"] = 'shipping';
calObj[1].daysClass["2022/11/12"] = 'shipping';
calObj[1].daysClass["2022/11/13"] = 'shipping';
calObj[1].daysClass["2022/11/19"] = 'shipping';
calObj[1].daysClass["2022/11/20"] = 'shipping';
calObj[1].daysClass["2022/11/26"] = 'shipping';
calObj[1].daysClass["2022/11/27"] = 'shipping';
calObj[1].daysClass["2022/11/1"] = 'Holyday';
calObj[1].daysClass["2022/11/2"] = 'Holyday';
calObj[1].daysClass["2022/11/23"] = 'Holyday';
calObj[1].daysClass["2022/12/3"] = 'shipping';
calObj[1].daysClass["2022/12/4"] = 'shipping';
calObj[1].daysClass["2022/12/10"] = 'shipping';
calObj[1].daysClass["2022/12/11"] = 'shipping';
calObj[1].daysClass["2022/12/17"] = 'shipping';
calObj[1].daysClass["2022/12/18"] = 'shipping';
calObj[1].daysClass["2022/12/24"] = 'shipping';
calObj[1].daysClass["2022/12/25"] = 'shipping';
calObj[1].daysClass["2022/12/29"] = 'shipping';
calObj[1].daysClass["2022/12/30"] = 'Holyday';
calObj[1].daysClass["2022/12/31"] = 'Holyday';
calObj[1].daysClass["2023/1/1"] = 'Holyday';
calObj[1].daysClass["2023/1/2"] = 'Holyday';
calObj[1].daysClass["2023/1/3"] = 'Holyday';
calObj[1].daysClass["2023/1/4"] = 'shipping';
calObj[1].daysClass["2023/1/7"] = 'shipping';
calObj[1].daysClass["2023/1/8"] = 'Holyday';
calObj[1].daysClass["2023/1/9"] = 'shipping';
calObj[1].daysClass["2023/1/14"] = 'shipping';
calObj[1].daysClass["2023/1/15"] = 'shipping';
calObj[1].daysClass["2023/1/21"] = 'shipping';
calObj[1].daysClass["2023/1/22"] = 'shipping';
calObj[1].daysClass["2023/1/28"] = 'shipping';
calObj[1].daysClass["2023/1/29"] = 'shipping';
calObj[1].daysClass["2023/2/4"] = 'shipping';
calObj[1].daysClass["2023/2/5"] = 'shipping';
calObj[1].daysClass["2023/2/11"] = 'shipping';
calObj[1].daysClass["2023/2/12"] = 'shipping';
calObj[1].daysClass["2023/2/18"] = 'shipping';
calObj[1].daysClass["2023/2/19"] = 'shipping';
calObj[1].daysClass["2023/2/23"] = 'Holyday';
calObj[1].daysClass["2023/2/25"] = 'shipping';
calObj[1].daysClass["2023/2/26"] = 'shipping';
calObj[1].daysClass["2023/3/4"] = 'shipping';
calObj[1].daysClass["2023/3/5"] = 'shipping';
calObj[1].daysClass["2023/3/11"] = 'shipping';
calObj[1].daysClass["2023/3/12"] = 'shipping';
calObj[1].daysClass["2023/3/18"] = 'shipping';
calObj[1].daysClass["2023/3/19"] = 'shipping';
calObj[1].daysClass["2023/3/21"] = 'shipping';
calObj[1].daysClass["2023/3/25"] = 'shipping';
calObj[1].daysClass["2023/3/26"] = 'shipping';
calObj[1].daysClass["2023/4/30"] = 'Holyday';
calObj[1].daysClass["2023/5/1"] = 'Holyday';
calObj[1].daysClass["2023/5/3"] = 'Holyday';
calObj[1].daysClass["2023/5/4"] = 'Holyday';
calObj[1].daysClass["2023/5/5"] = 'Holyday';
calObj[1].daysClass["2023/5/6"] = 'shipping';
calObj[1].daysClass["2023/5/7"] = 'shipping';
calObj[1].daysClass["2023/5/13"] = 'shipping';
calObj[1].daysClass["2023/5/14"] = 'shipping';
calObj[1].daysClass["2023/5/19"] = 'shipping';
calObj[1].daysClass["2023/5/20"] = 'shipping';
calObj[1].daysClass["2023/5/21"] = 'shipping';
calObj[1].daysClass["2023/5/27"] = 'shipping';
calObj[1].daysClass["2023/5/28"] = 'Holyday';
calObj[1].daysClass["2023/6/3"] = 'shipping';
calObj[1].daysClass["2023/6/4"] = 'shipping';
calObj[1].daysClass["2023/6/10"] = 'shipping';
calObj[1].daysClass["2023/6/11"] = 'shipping';
calObj[1].daysClass["2023/6/17"] = 'shipping';
calObj[1].daysClass["2023/6/18"] = 'shipping';
calObj[1].daysClass["2023/6/24"] = 'Holyday';
calObj[1].daysClass["2023/6/25"] = 'shipping';
calObj[1].daysClass["2023/7/17"] = 'shipping';
calObj[1].daysClass["2023/8/11"] = 'shipping';
//calObj[1].daysClass["2023/10/9"] = 'shipping';
calObj[1].daysClass["2023/11/3"] = 'shipping'; //文化の日
calObj[1].daysClass["2023/11/23"] = 'shipping'; //勤労感謝の日
calObj[1].daysClass["2024/1/4"] = 'shipping';
calObj[1].daysClass["2024/2/12"] = 'shipping';
calObj[1].daysClass["2024/4/30"] = 'Holyday';
calObj[1].daysClass["2024/5/1"] = 'Holyday';
calObj[1].daysClass["2024/5/5"] = 'Holyday';
calObj[1].daysClass["2024/5/10"] = 'shipping';
calObj[1].daysClass["2024/5/26"] = 'Holyday';
calObj[1].daysClass["2024/6/29"] = 'Holyday';
calObj[1].daysClass["2024/5/28"] = 'shipping';
calObj[1].daysClass["2024/11/8"] = 'shipping';
calObj[1].daysClass["2024/12/30"] = 'Holyday';
calObj[1].daysClass["2024/12/31"] = 'Holyday';
calObj[1].daysClass["2025/1/1"] = 'Holyday';
calObj[1].daysClass["2025/1/2"] = 'Holyday';
calObj[1].daysClass["2025/1/3"] = 'Holyday';
calObj[1].daysClass["2025/1/4"] = 'Holyday';
calObj[1].daysClass["2025/1/5"] = 'Holyday';
calObj[1].daysClass["2025/4/30"] = 'Holyday';
calObj[1].daysClass["2025/4/15"] = 'shipping';
calObj[1].daysClass["2025/4/16"] = 'shipping';
calObj[1].daysClass["2025/5/1"] = 'Holyday';
calObj[1].daysClass["2025/5/6"] = 'shipping';
calObj[1].daysClass["2025/5/23"] = 'shipping';
calObj[1].daysClass["2025/6/28"] = 'Holyday';
calObj[1].daysClass["2025/7/13"] = 'Holyday';
calObj[1].daysClass["2025/10/31"] = 'Holyday';
calObj[1].daysClass["2025/11/7"] = 'shipping';
calObj[1].daysClass["2025/11/24"] = 'shipping';
calObj[1].daysClass["2025/12/30"] = 'Holyday';
calObj[1].daysClass["2025/12/31"] = 'Holyday';
calObj[1].daysClass["2026/1/1"] = 'Holyday';
calObj[1].daysClass["2026/1/2"] = 'Holyday';
calObj[1].daysClass["2026/1/3"] = 'Holyday';
calObj[1].daysClass["2026/3/20"] = 'shipping'; //春分の日
calObj[1].daysClass["2026/5/1"] = 'Holyday'; 
calObj[1].daysClass["2026/6/27"] = 'Holyday'; //倉庫点検
calObj[1].daysClass["2026/8/23"] = 'Holyday'; //電気点検
calObj[1].daysClass["2026/9/22"] = 'shipping'; //国民の休日
calObj[1].daysClass["2026/11/2"] = 'Holyday';
//calObj[1].xDaysLater[1] = 'shipping;出荷日'; //
//calObj[1].daysClass["5/15"] = 'shipping;出荷日';


// ["xDay"] 毎月○日のクラス指定
calObj[1].xDays = new Array();
//calObj[0].xDays[1] = 'Sale;毎月1日は激安セールの日☆'; // 毎月1日にSaleクラスを指定ってことね。

// ["week"] 毎週○曜日の場合
calObj[1].week = new Array();
calObj[1].week[0] = "shipping"; // Sun
calObj[1].week[1]; // Mon
calObj[1].week[2]; // Tue
calObj[1].week[3]; // Wed
calObj[1].week[4]; // Thu
calObj[1].week[5]; // Fri
calObj[1].week[6] = "shipping"; // Sat

// (○月) 第× △曜日の場合
calObj[1].month = new Object();
// 毎月「曜日-第○」 日:0 / 月:1 / 火:2 / 水:3 / 木:4 / 金:5 / 土:6
//calObj[0].month["0-4"] = 'Holyday;第2月曜日'; // 第2火曜日はHolydayクラス指定
//calObj[0].month["2-2"] = 'Holyday;第2火曜日は定休日です☆'; // 第2火曜日はHolydayクラス指定
//tddfsfcalObj[0].month["2-4"] = 'Holyday;第4火曜日は定休日です☆'; // 第4火曜日はHolydayクラス指定
// 固定月「月-曜日-第○」 日:0 / 月:1 / 火:2 / 水:3 / 木:4 / 金:5 / 土:6
//calObj[1].month["1-1-2"] = 'Holyday;成人の日'; // 1月 月曜日(1) 第2 ということね。
//calObj[1].month["7-1-3"] = 'Holyday;海の日'; // 7月 月曜日(1) 第3 ということね。
//calObj[1].month["9-1-3"] = 'Holyday;敬老の日'; // 9月 月曜日(1) 第3 ということね。
calObj[1].month["10-1-2"] = 'shipping'; // 10月 月曜日(1) 第2 ということね。

// ["backward"] 過去の日付のクラス名(指定しない場合はnull)
calObj[1].backward = 'backward';

// カレンダーをクリックできるようにする場合 (有効 : true / 無効 : false)
// クラス指定でURLが指定されている場合はそっちが優先されます。
calObj[1].click = false;

// クリックした時に開くURL ( _YEAR_ : 年 / _MONTH_ : 月 / _DAY_ : 日 )
calObj[1].clickURI = '';

// クリック可能にしたいクラス名 (すべての日をクリック可能にする場合は空にしてください)
// Holyday と指定した場合はclassがHolyday指定された日付だけクリックできるようになります。
calObj[1].clickClassName = "";

// 優先度 クラス指定する順番が変わります。
calObj[1].priority = new Array('week','xDay','xDaysLater','day','backward');
calObj[1].defaultMonth = 0; //翌月から表示ってことね。
// カレンダー1の設定はここまで

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// 以下、さわらぬ神にたたりなし
calObj.calendars = new Array();
calObj.days = new Array(0,31,28,31,30,31,30,31,31,30,31,30,31);
calObj.weekName = new Array("日","月","火","水","木","金","土");
calObj.monthName = new Array('','1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月');
calObj.date = new Date();
calObj.date = new Date(calObj.date.getFullYear() + "/" + (calObj.date.getMonth() + 1) + "/" + calObj.date.getDate() + " 00:00:00");
calObj.day = calObj.date.getDate();
calObj.month = calObj.date.getMonth() + 1;
calObj.year = calObj.date.getFullYear();
calObj.currentList = null;

function cal_init(){
	var d = window.document;
	var tagObj = d.getElementsByTagName("div");
	var calToday = new Date();
	for(var i=0;i<tagObj.length;i++){
		if(tagObj[i].className == "cal_wrapper"){
			var calId = Number(tagObj[i].id.substring(3,tagObj[i].id.length));
			calObj.calendars.push(calId);
			if(0 < (calObj.month + calObj[calId].defaultMonth) && (calObj.month + calObj[calId].defaultMonth) < 13)
				calObj[calId].currentMonth = new Date(calObj.year+"/"+(calObj.month + calObj[calId].defaultMonth)+"/"+"1 00:00:00");
			else
				calObj[calId].currentMonth = new Date((calObj.year+1)+"/"+((calObj.month + calObj[calId].defaultMonth)%12)+"/"+"1 00:00:00");
			cal_create(calId);
		}
	}
}
function cal_create(calId){
	var d = window.document;
	var day = calObj[calId].currentMonth.getDate();
	var month = calObj[calId].currentMonth.getMonth() + 1;
	var year = calObj[calId].currentMonth.getFullYear();
	var week = calObj[calId].currentMonth.getDay();
	var tdTextListArr = new Array();
	var bisDay = 0;
	var MonthDays = calObj.days[month];
	var WeekCnt = new Array();
	if(month == 2){
		if(year % 100 == 0 || year % 4 != 0){
			if(year % 400 != 0)
				bisDay = 0;
			else
				bisDay = 1;
		}
		else if(year % 4 == 0)
			bisDay = 1;
		else
			bisDay = 0;
	}
	MonthDays += bisDay;
	var calHTML = "<table border='0' cellspacing='0' cellpadding='0' class='cal'>";
	calHTML += "<tr><th colspan='7'>";
	calHTML += "<div class='cal_ui'>";
	calHTML += "<input type='button' onclick='cal_move("+calId+",-1);' value='&lt; prev' />";
	calHTML += "<input type='button' onclick='cal_move("+calId+",null);' value='-' />";
	calHTML += "<input type='button' onclick='cal_move("+calId+",1);' value='next &gt;' />";
	calHTML += "</div>";
	calHTML += "<p>" + year + "年" + calObj.monthName[month] + "</p></th></tr>";
	calHTML += "<tr class='headline'>";
	for(var i=0;i<calObj.weekName.length;i++)
		calHTML += "<td>" + calObj.weekName[i] + "</td>";
	calHTML += "</tr><tr>";
	for(var i=0;i<week;i++)
		calHTML += "<td>&nbsp;</td>";
	for(dayCnt=1;dayCnt<=(calObj.days[month]+bisDay);dayCnt++){
		var dayStr = year + "/" + month + "/" + dayCnt;
		var dayStrN = month + "/" + dayCnt;
		if(WeekCnt[week] == undefined)
			WeekCnt[week] = 0;
		WeekCnt[week]++;



		var monStr = '' + month + '-' + week + '-' + WeekCnt[week];
		var weekStr = '' + week + '-' + WeekCnt[week];
		//alert(weekStr);

		var dayClass = new Object();
		var dayClassText = new Object();
		var currentDayDate = new Date(year + "/" + month + "/" + dayCnt + " 00:00:00");
		var laterDay = Math.floor((currentDayDate.getTime() - calObj.date.getTime()) / 1000 / (60 * 60 * 24));
		var tdId = "td_"+calId+"_"+year+"_"+month+"_"+dayCnt;

		// backward
		if(calObj[calId].backward != null && currentDayDate.getTime() < calObj.date.getTime())
			dayClass["backward"] = calObj[calId].backward;

		// week
		if(calObj[calId].month[weekStr] != undefined)
			dayClass["week"] = calObj[calId].month[weekStr];
		else if(calObj[calId].month[monStr] != undefined)
			dayClass["week"] = calObj[calId].month[monStr];
		else if(calObj[calId].week[week] != undefined){
			if(typeof(calObj[calId].week[week]) == "object" && calObj[calId].week[week][WeekCnt[week]] != undefined){
				dayClass["week"] = calObj[calId].week[week][WeekCnt[week]];
			}
			else if(calObj[calId].week[week] != undefined && typeof(calObj[calId].week[week]) != "object")
				dayClass["week"] = calObj[calId].week[week];
		}
		// xDay
		if(calObj[calId].xDays[dayCnt] != undefined)
			dayClass["xDay"] = calObj[calId].xDays[dayCnt];

		// xDaysLater
		if(calObj[calId].xDaysLater[laterDay] != undefined)
			dayClass["xDaysLater"] = calObj[calId].xDaysLater[laterDay];

		// day
		if(calObj[calId].daysClass[dayStr] != undefined)
			dayClass["day"] = calObj[calId].daysClass[dayStr];
		else if(calObj[calId].daysClass[dayStrN] != undefined)
			dayClass["day"] = calObj[calId].daysClass[dayStrN];

		var tdClassArr = new Array();
		var tdTextArr = new Array();
		var tdLinkArr = new Array();
		var tdClassStr = "";
		var tdTextStr = "";
		var tdMouse = "";
		var tdClassNames = new Object();
		for(var ci=0;ci<calObj[calId].priority.length;ci++){
			if(dayClass[calObj[calId].priority[ci]] != undefined){
				var splitArr = new Array();
				splitArr = dayClass[calObj[calId].priority[ci]].split(';');
				tdClassArr.push(splitArr[0]);
				tdClassNames[splitArr[0]] = true;
				if(splitArr[1] != undefined){
					tdTextArr.push(splitArr[1]);
					var tdTextListLink = "";
					if(splitArr[2] != undefined)
						tdTextListLink = " onclick=\"cal_open(\'"+splitArr[2]+"\')\"";
					tdTextListArr.push('<ol><li id="'+tdId+'_li" onmouseover="cal_list2day_over(this)" onmouseout="cal_list2day_out(this)" value="'+dayCnt+'"'+tdTextListLink+'>'+splitArr[1]+'</li></ol>');
				}
				if(splitArr[2] != undefined)
					tdLinkArr.push(splitArr[2]);
			}
		}
		if(tdTextArr.length > 0){
			tdTextStr = "<span id='"+tdId+"'>" + tdTextArr[0] + "</span>";
			tdMouse = " onmouseover=\"cal_disp_text(\'"+tdId+"\')\" onmouseout=\"cal_hide_text(\'"+tdId+"\')\"";
			tdClassArr.push('pointer');
		}
		if(tdLinkArr.length > 0)
			tdMouse += " onclick=\"cal_open(\'"+tdLinkArr[0]+"\')\"";
		else if(calObj[calId].click){
			var clickOpenURI = calObj[calId].clickURI;
			clickOpenURI = clickOpenURI.replace(/_YEAR_/ig,year);
			clickOpenURI = clickOpenURI.replace(/_MONTH_/ig,month);
			clickOpenURI = clickOpenURI.replace(/_DAY_/ig,dayCnt);
			if((calObj[calId].clickClassName != "" && tdClassNames[calObj[calId].clickClassName]) || calObj[calId].clickClassName == ""){
				tdMouse += " onclick=\"cal_open(\'"+clickOpenURI+"\')\"";
				tdClassArr.push('pointer');
			}
		}
		if(tdClassArr.length > 0)
			tdClassStr = " class='" + tdClassArr.join(' ') + "'";
		calHTML += "<td id='"+tdId+"_td'><div"+tdClassStr+tdMouse+">" + dayCnt + tdTextStr + "</div></td>";
		if(week == 6){
			calHTML += "</tr>";
			if(dayCnt < calObj.days[month])
				calHTML += "<tr>";
			week = 0;
		}
		else
			week++;
	}
	while(week <= 6 && week != 0){
		calHTML += "<td>&nbsp;</td>";
		if(week == 6)
			calHTML += "</tr>";
		week++;
	}
	calHTML += "</table>";
	d.getElementById('cal'+calId).innerHTML = calHTML;

	// list
	if(tdTextListArr.length > 0 && d.getElementById('schedule'+calId)){
		d.getElementById('schedule'+calId).innerHTML = tdTextListArr.join('');
	}
	// /list
}
function cal_list2day_over(obj){
	var d = window.document;
	var dayId = obj.id.substring(0,obj.id.indexOf('_li'));
	if(d.getElementById(calObj.currentList))
		d.getElementById(calObj.currentList).style.backgroundColor = '#FFFFFF';
	calObj.currentList = dayId+'_td';
	if(d.getElementById(dayId+'_td'))
		d.getElementById(dayId+'_td').style.backgroundColor = '#CCCCCC';
}
function cal_list2day_out(obj){
	var d = window.document;
	var dayId = obj.id.substring(0,obj.id.indexOf('_li'));
	if(d.getElementById(calObj.currentList))
		d.getElementById(calObj.currentList).style.backgroundColor = '#FFFFFF';
}
function cal_open(uri){
	window.open(uri);
}
function cal_disp_text(textId){
	var d = window.document;
	if(navigator.userAgent.indexOf('MSIE') == -1)
		d.getElementById(textId).style.display = "block";
}
function cal_hide_text(textId){
	var d = window.document;
	d.getElementById(textId).style.display = "none";
}

function cal_move(calId,m){
	if(m == null)
		calObj[calId].currentMonth = new Date(calObj.year+"/"+(calObj.month)+"/"+"1 00:00:00");
	else {
		var day = calObj[calId].currentMonth.getDate();
		var month = calObj[calId].currentMonth.getMonth() + 1;
		var year = calObj[calId].currentMonth.getFullYear();
		if(0 < month + m && month + m < 13)
			calObj[calId].currentMonth = new Date(year+"/"+(month + m)+"/"+"1 00:00:00");
		else if((month + m) < 1){
			year--;
			month = 12;
			calObj[calId].currentMonth = new Date(year+"/"+(month)+"/"+"1 00:00:00");
		}
		else {
			year++;
			month = 1;
			calObj[calId].currentMonth = new Date(year+"/"+(month)+"/"+"1 00:00:00");
		}
	}
	cal_create(calId);
}
function cal_clone(obj) {
	var dest;
	if(typeof obj == 'object'){
		if(obj instanceof Array){
			dest = new Array();
			for(i=0;i<obj.length;i++)
				dest[i] = cal_clone(obj[i]);
		}
		else {
			dest = new Object();
			for(prop in obj)
				dest[prop] = cal_clone(obj[prop]);
		}
	}
	else
		dest = obj;
	return dest;
}
function cal_getMonth(){

}
cal_init();
